
































import Vue from 'vue';
import { BProgress, BProgressBar } from 'bootstrap-vue';

export default Vue.extend({
  components: {
    BProgress,
    BProgressBar,
  },
  props: {
    uploads: {
      type: Array,
      required: true,
    },
  },
});
